<template>
  <aside
    class="sidebar"
    :class="{ '-collapsed': ! sidebarVisible }"
  >
    <sidebar-header/>

    <ul class="menu">
      <router-link
        to="/"
        v-slot="{ href, navigate, isExactActive }"
      >
        <sidebar-item
          @click="navigate"
          :is-active="isExactActive"
          :href="href"
          icon="cube-outline"
        >
          Dashboard
        </sidebar-item>
      </router-link>

      <router-link
        to="/compliance"
        v-slot="{ isActive }"
      >
        <sidebar-item
          :is-active="isActive"
          icon="search-outline"
        >
          Consultas
          <template slot="children">
            <router-link
              :to="{ name: 'Compliance-Physical-Person-Create' }"
              v-slot="{ href, navigate, isActive }"
            >
              <sidebar-item-child :href="href" @click="navigate" :is-active="isActive">Pessoa Física</sidebar-item-child>
            </router-link>

            <router-link
              :to="{ name: 'Compliance-Legal-Person-Create' }"
              v-slot="{ href, navigate, isActive }"
            >
              <sidebar-item-child :href="href" @click="navigate" :is-active="isActive">Pessoa Jurídica</sidebar-item-child>
            </router-link>

            <router-link
              :to="{ name: 'Compliance-Vehicles-Create' }"
              v-slot="{ href, navigate, isActive }"
            >
              <sidebar-item-child :href="href" @click="navigate" :is-active="isActive">Veículos</sidebar-item-child>
            </router-link>

            <router-link
              :to="{ name: 'Compliance-Properties-Create' }"
              v-slot="{ href, navigate, isActive }"
            >
              <sidebar-item-child :href="href" @click="navigate" :is-active="isActive">Imóveis</sidebar-item-child>
            </router-link>

            <router-link
              :to="{ name: 'Compliance-Others-Create' }"
              v-slot="{ href, navigate, isActive }"
            >
              <sidebar-item-child :href="href" @click="navigate" :is-active="isActive">Outros Documentos</sidebar-item-child>
            </router-link>
          </template>
        </sidebar-item>
      </router-link>

      <router-link
        to="/template"
        v-slot="{ isActive }"
      >
        <sidebar-item
          :is-active="isActive"
          icon="file-tray-full-outline"
        >
          Templates
          <template slot="children">
            <router-link
              :to="{ name: 'Template-Physical-Person' }"
              v-slot="{ href, navigate, isActive }"
            >
              <sidebar-item-child :href="href" @click="navigate" :is-active="isActive">Pessoa Física</sidebar-item-child>
            </router-link>

            <router-link
              :to="{ name: 'Template-Legal-Person' }"
              v-slot="{ href, navigate, isActive }"
            >
              <sidebar-item-child :href="href" @click="navigate" :is-active="isActive">Pessoa Jurídica</sidebar-item-child>
            </router-link>

            <router-link
              :to="{ name: 'Template-Vehicle' }"
              v-slot="{ href, navigate, isActive }"
            >
              <sidebar-item-child :href="href" @click="navigate" :is-active="isActive">Veículos</sidebar-item-child>
            </router-link>

            <router-link
              :to="{ name: 'Template-Property' }"
              v-slot="{ href, navigate, isActive }"
            >
              <sidebar-item-child :href="href" @click="navigate" :is-active="isActive">Imóveis</sidebar-item-child>
            </router-link>

            <router-link
              :to="{ name: 'Template-Other' }"
              v-slot="{ href, navigate, isActive }"
            >
              <sidebar-item-child :href="href" @click="navigate" :is-active="isActive">Outros Documentos</sidebar-item-child>
            </router-link>
          </template>
        </sidebar-item>
      </router-link>

      <router-link
        to="/batch"
        v-slot="{ isActive }"
      >
        <sidebar-item
          :is-active="isActive"
          icon="layers-outline"
        >
          Consultas em Lote
          <template slot="children">
            <router-link
              :to="{ name: 'Batch-Physical-Person' }"
              v-slot="{ href, navigate, isActive }"
            >
              <sidebar-item-child :href="href" @click="navigate" :is-active="isActive">Pessoa Física</sidebar-item-child>
            </router-link>

            <router-link
              :to="{ name: 'Batch-Legal-Person' }"
              v-slot="{ href, navigate, isActive }"
            >
              <sidebar-item-child :href="href" @click="navigate" :is-active="isActive">Pessoa Jurídica</sidebar-item-child>
            </router-link>

            <router-link
              :to="{ name: 'Batch-Vehicle' }"
              v-slot="{ href, navigate, isActive }"
            >
              <sidebar-item-child :href="href" @click="navigate" :is-active="isActive">Veículos</sidebar-item-child>
            </router-link>

            <router-link
              :to="{ name: 'Batch-Property' }"
              v-slot="{ href, navigate, isActive }"
            >
              <sidebar-item-child :href="href" @click="navigate" :is-active="isActive">Imóveis</sidebar-item-child>
            </router-link>

            <router-link
              :to="{ name: 'Batch-Other' }"
              v-slot="{ href, navigate, isActive }"
            >
              <sidebar-item-child :href="href" @click="navigate" :is-active="isActive">Outros Documentos</sidebar-item-child>
            </router-link>
          </template>
        </sidebar-item>
      </router-link>

      <router-link
        :to="{ name: 'Recurrent' }"
        v-slot="{ href, navigate, isActive }"
      >
        <sidebar-item
          @click="navigate"
          :is-active="isActive"
          :href="href"
          icon="timer-outline"
        >
          Consultas Recorrentes
        </sidebar-item>
      </router-link>

      <router-link
        :to="{ name: 'Consultations-Results' }"
        v-slot="{ href, navigate, isActive }"
      >
        <sidebar-item
          @click="navigate"
          :is-active="isActive"
          :href="href"
          icon="reader-outline"
        >
          Resultados
        </sidebar-item>
      </router-link>

      <router-link
        :to="{ name: 'Consultations-Results-Batch' }"
        v-slot="{ href, navigate, isActive }"
      >
        <sidebar-item
          @click="navigate"
          :is-active="isActive"
          :href="href"
          icon="reader-outline"
        >
          Resultados em Lote
        </sidebar-item>
      </router-link>

      <router-link
          :to="{ name: 'Endpoint-Index' }"
          v-slot="{ href, navigate, isActive }"
          v-if="user.admin"
      >
        <sidebar-item
            @click="navigate"
            :is-active="isActive"
            :href="href"
            icon="newspaper-outline"
        >
          Consultas
        </sidebar-item>
      </router-link>

      <router-link
          :to="{ name: 'Invite-Index' }"
          v-slot="{ href, navigate, isActive }"
          v-if="user.admin"
      >
        <sidebar-item
            @click="navigate"
            :is-active="isActive"
            :href="href"
            icon="people-outline"
        >
          Convites
        </sidebar-item>
      </router-link>

      <router-link
        to="/plan"
        v-slot="{ isActive }"
      >
        <sidebar-item
          :is-active="isActive"
          icon="card-outline"
          v-if="user.plan.prepaid && user.role === role.master"
        >
          Assinatura
          <template slot="children">
            <router-link
              :to="{ name: 'Plans' }"
              v-slot="{ href, navigate, isActive }"
            >
              <sidebar-item-child :href="href" @click="navigate" :is-active="isActive">Plano</sidebar-item-child>
            </router-link>

            <router-link
              :to="{ name: 'Recharge' }"
              v-slot="{ href, navigate, isActive }"
              v-if="user.plan.id && user.plan.prepaid && ![6].includes(user.plan.id)"
            >
              <sidebar-item-child :href="href" @click="navigate" :is-active="isActive">Crédito Extra</sidebar-item-child>
            </router-link>
          </template>
        </sidebar-item>
      </router-link>

      <router-link
        to="/my-account"
        v-slot="{ isActive }"
      >
        <sidebar-item
          :is-active="isActive"
          icon="cog-outline"
        >
          Minha Conta
          <template slot="children">
            <router-link
              :to="{ name: 'Auth-My-Account-Personal-Information' }"
              v-slot="{ href, navigate, isExactActive }"
            >
              <sidebar-item-child :href="href" @click="navigate" :is-active="isExactActive">Meus Dados</sidebar-item-child>
            </router-link>

            <router-link
              :to="{ name: 'History-Purchases' }"
              v-slot="{ href, navigate, isExactActive }"
              v-if="user.role === role.master"
            >
              <sidebar-item-child :href="href" @click="navigate" :is-active="isExactActive">Histórico Compras</sidebar-item-child>
            </router-link>

            <router-link
              :to="{ name: 'History-Use' }"
              v-slot="{ href, navigate, isExactActive }"
              v-if="user.role === role.master"
            >
              <sidebar-item-child :href="href" @click="navigate" :is-active="isExactActive">Histórico Utilização</sidebar-item-child>
            </router-link>

            <router-link
              :to="{ name: 'Metrics-Usage' }"
              v-slot="{ href, navigate, isExactActive }"
              v-if="user.role === role.master"
            >
              <sidebar-item-child :href="href" @click="navigate" :is-active="isExactActive">Relatórios</sidebar-item-child>
            </router-link>
          </template>
        </sidebar-item>
      </router-link>

      <sidebar-item icon="help-outline">
        Ajuda
        <template slot="children">
          <sidebar-item-child
            href="https://www.plexi.com.br"
            target="_blank"
          >Site</sidebar-item-child>

          <sidebar-item-child
            href="http://developers.plexi.com.br"
            target="_blank"
          >Documentação</sidebar-item-child>
        </template>
      </sidebar-item>
    </ul>
  </aside>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import SidebarHeader from '@/dashboard/components/layout/sidebar/SidebarHeader.vue';
import SidebarItem from '@/dashboard/components/layout/sidebar/SidebarItem.vue';
import SidebarItemChild from '@/dashboard/components/layout/sidebar/SidebarItemChild.vue';

export default {
  name: 'Sidebar',

  methods: {
    /**
     * Check if screen is md size.
     *
     * @returns {boolean}
     */
    screenIsMd(screenSize) {
      const mdSize = 768;

      return screenSize >= mdSize;
    },

    /**
     * Hide or show the sidebar according to the screen size. If
     * the screen size is less md, will hide, otherwise will show.
     *
     * @param screenSize
     */
    hideOrShowSidebarAccordingToTheScreenSize(screenSize) {
      const showSideBar = this.screenIsMd(screenSize);
      const sidebarEvent = showSideBar
        ? 'dashboard/showSidebar'
        : 'dashboard/hideSidebar';

      if (showSideBar !== this.sidebarVisible) {
        this.$store.commit(sidebarEvent);
      }
    },

    ...mapMutations('dashboard', [
      'hideSidebar',
    ]),
  },

  mounted() {
    this.hideOrShowSidebarAccordingToTheScreenSize(window.innerWidth);

    let lastInnerWidthResized = window.innerWidth;
    window.addEventListener('resize', ({ target }) => {
      if (target.innerWidth !== lastInnerWidthResized) {
        this.hideOrShowSidebarAccordingToTheScreenSize(target.innerWidth);
      }

      lastInnerWidthResized = target.innerWidth;
    });
  },

  computed: {
    ...mapState('dashboard', [
      'sidebarVisible',
    ]),
    ...mapState('auth', [
      'user',
      'role',
    ]),
  },

  watch: {
    $route() {
      if (this.sidebarVisible && !this.screenIsMd(window.innerWidth)) {
        this.hideSidebar();
      }
    },
  },

  components: {
    SidebarHeader,
    SidebarItem,
    SidebarItemChild,
  },
};
</script>

<style lang="scss" scoped>
  aside.sidebar {
    background-color: #ffffff;
    border-right: 1px solid #e2e8f0;
    top: 0;
    width: 280px;
    max-width: 280px;
    transition-duration: .4s;
    transition-timing-function: cubic-bezier(.25,.8,.25,1);
    transition-property: visibility, margin-left, margin-right, transform, width, max-width, min-width;
    position: fixed;
    bottom: 0;
    z-index: 2;
    overflow-y: auto;
    max-height: 100vh;
    min-height: 100vh;

    &.-collapsed {
      margin-left: -280px;
      visibility: hidden;
    }

    .menu {
      display: flex;
      flex-direction: column;
      flex: 1 0 auto;
      margin-top: 5px;
    }
  }
</style>
